import { useCallback, useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';

// Isolate the email's inline styles from Universe. No scripts, forms or external resources.
export default function InvoiceEmailPreview({ html }) {
    const frame = useRef(null);
    const [height, setHeight] = useState(1100);
    const measure = useCallback(() => {
        const body = frame.current?.contentDocument?.body;
        if (body) {
            const measured = Math.ceil(Math.max(body.scrollHeight, body.getBoundingClientRect().height));
            if (measured > 0) setHeight(measured);
        }
    }, []);
    useEffect(() => {
        if (typeof ResizeObserver === 'undefined' || !frame.current) return;
        const observer = new ResizeObserver(measure);
        observer.observe(frame.current);
        return () => observer.disconnect();
    }, [measure]);
    const document = html.replace('<head>', `<head><meta http-equiv="Content-Security-Policy" content="default-src 'none'; style-src 'unsafe-inline'; img-src data:; base-uri 'none'; form-action 'none';"><style>a{pointer-events:none}</style>`);
    return <Box component="iframe" ref={frame} title="Invoice email preview" srcDoc={document}
        sandbox="allow-same-origin" tabIndex={-1} onLoad={measure}
        sx={{ display: 'block', width: '100%', height, border: 0, pointerEvents: 'none', bgcolor: '#f4f5f8' }} />;
}
